module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleList":{"pagination":{"buttonLoadMore":{"ariaLabel":"Zobrazit další články","text":"Další články"}}}},"de":{"ArticleList":{"pagination":{"buttonLoadMore":{"ariaLabel":"Andere Bestellungen anzeigen","text":"Andere Bestellungen"}}}},"sk":{"ArticleList":{"pagination":{"buttonLoadMore":{"ariaLabel":"Zobraziť ďalšie objednávky","text":"Ďalšie objednávky"}}}}}')
  delete Component.options._Ctor
}
